import ApiCLient from '@/api/client';

const path = require('path');

class FtpAPI extends ApiCLient {

  constructor() {
    super();
  }
  async getFTPChoices(usergroupId) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp-choices/?usergroup_id=${usergroupId}`
    );
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** CREATE */
  async createFTPFormat(data) {
    const response = await this.post(this.FTP_API_APTH, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async createFTPResource(id, data, async = true) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/?asynchrone=${async}`
    );
    const response = await this.put(url, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** UPDATE */
  async updateFTPFormat(id, format) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/`
    );
    const response = await this.patch(url, format);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  // async updateFTPResource(resourceData, data, async = true) {
  //   const url = new URL(path.join(`${i18n.locale}${this.RESOURCE_API_PATH}`, `ftp/${resourceData.id}/`), DOMAIN);
  //   const response = await this.patch(
  //     url,
  //     { href: resourceData.selectedFtpFiles.map(el => el.value) }
  //     
  //   );
  //   const url2 = new URL(
  //     path.join(`${i18n.locale}${this.RESOURCE_API_PATH}`, `ftp/${resourceData.id}/?asynchrone=${async}`),
  //     DOMAIN
  //   );
  //   const response2 = await this.patch(url2, { kwargs: data.kwargs } );
  //   if (response2.status === 200) {
  //     return response.data;
  //   }
  //   return false;
  // }

  /** SCENARII */
  async getFTPResourceScenarios(id) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/_scenarios/`
    );
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runFTPResourceScenario(id, scenarioId, data) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`
    );
    const response = await this.post(url, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  /** SCHEDULER */
  async setFTPScheduler(id, data) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/scenario-execution-frequency/`
    );
    const response = await this.post(url, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async updateFTPScheduler(id, data, scenarioId) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/scenario-execution-frequency/${scenarioId}/`
    );
    const response = await this.patch(url, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async getFTPScheduler(id) {
    const url = path.join(
      this.RESOURCE_API_PATH,
      `ftp/${id}/scenario-execution-frequency/`
    );
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
};

const ftpAPI = new FtpAPI();
export default ftpAPI;